/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'ai-mate.agent-header-banner-label': 'Agentenbanner',
  'ai-mate.agent-list.all-agents-section-title': 'Alle Agenten',
  'ai-mate.agent-list.beta-lozenge-title': 'Beta',
  'ai-mate.agent-list.change-owner-success-flag-description':
    'Sie haben den Besitzer von {agentName} in {newOwnerName} geändert.',
  'ai-mate.agent-list.change-owner-success-flag-title': 'Besitzer wurde erfolgreich geändert',
  'ai-mate.agent-list.delete-agent-confirm-body':
    'Möchten Sie diesen Agenten wirklich löschen? Der Vorgang kann nicht rückgängig gemacht werden.',
  'ai-mate.agent-list.delete-agent-confirm-title': '"{agentName}" löschen?',
  'ai-mate.agent-list.delete-agent-error': 'Agent konnte nicht gelöscht werden',
  'ai-mate.agent-list.delete-agent-error-flag-description':
    'Beim Löschen des Agenten ist ein Fehler aufgetreten. Versuchen Sie es später erneut.',
  'ai-mate.agent-list.delete-agent-error-flag-title': 'Agent konnte nicht gelöscht werden',
  'ai-mate.agent-list.delete-agent-error.agent-in-use':
    'Der Agent wird derzeit verwendet. Versuchen Sie es später erneut.',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': 'Dieser Agent wurde nicht gefunden.',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner':
    'Sie können keine Agenten löschen, die Sie nicht selbst erstellt haben. Bitte kontaktieren Sie den Besitzer des Agenten.',
  'ai-mate.agent-list.delete-agent-success-flag-description': 'Sie haben {agentName} gelöscht.',
  'ai-mate.agent-list.delete-agent-success-flag-title': 'Agent gelöscht',
  'ai-mate.agent-list.development-section-title': 'Entwicklungsagenten',
  'ai-mate.agent-list.load-more-button-loading': 'Weitere Agenten werden geladen …',
  'ai-mate.agent-list.load-more-button-ready': 'Mehr laden',
  'ai-mate.agent-list.loading-agents': 'Agenten werden geladen …',
  'ai-mate.agent-list.no-results': 'Keine Ergebnisse gefunden für "{searchValue}".',
  'ai-mate.agent-list.recommended-agents-section-title': 'Empfohlen',
  'ai-mate.agent-list.searching-agents': 'Agenten werden gesucht …',
  'ai-mate.agent-list.templates-description':
    'Nutzen Sie diese Vorlagen, um Ihren eigenen Entwicklungsagenten zu erstellen. Wählen Sie die passende Agentenvorlage für Ihre Aufgabe aus, klicken Sie auf "Vorlage verwenden" und füllen Sie dann die Eingabeaufforderung der Vorlage mit spezifischen Details wie Repository, Ordner, Sprache und Bibliothek aus. Erstellen Sie maßgeschneiderte Entwicklungsagenten zum Programmieren verschiedener Aufgaben, Projekte oder Repositorys.',
  'ai-mate.agent-list.templates-lozenge-title': 'Vorlage',
  'ai-mate.agent-list.templates-title': 'Vorlagen zum Programmieren',
  'ai-mate.agent-message.agent-not-found': 'Agent wurde nicht gefunden.',
  'ai-mate.agent-message.convo-title': 'Chat mit {agentName} durch Einbettung eines intelligenten Links ausgelöst',
  'ai-mate.agent-message.copy-link': 'Agenten-Link kopieren',
  'ai-mate.agent-message.prompt': 'Prompt',
  'ai-mate.agent-message.prompt-placeholder': 'Schreiben Sie eine Nachricht an {agentName}',
  'ai-mate.agent-message.prompt-submit': 'Senden',
  'ai-mate.agent-message.view-profile': 'Profil anzeigen',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': 'Abbrechen',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': 'Löschen',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': 'Agent · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': 'Mit {agentName} chatten',
  'ai-mate.agent-profile-info.copy-agent-link-clicked-tooltip': 'URL kopiert',
  'ai-mate.agent-profile-info.copy-agent-link-tooltip': 'Link kopieren',
  'ai-mate.agent-profile-info.hidden-icon': 'Ausgeblendet',
  'ai-mate.agent-profile-info.hidden-tooltip': 'Agent wird nicht in den Suchergebnissen angezeigt',
  'ai-mate.agent-profile-info.star-agent-tooltip': 'Agent mit Stern markieren',
  'ai-mate.agent-selector.agent-not-found': 'Agent wurde nicht gefunden.',
  'ai-mate.agent-selector.default-agent-description':
    'Erhalten Sie Antworten, entwickeln Sie neue Ideen und beschleunigen Sie die tägliche Arbeit.',
  'ai-mate.agent-selector.default-agent-name': 'Chat',
  'ai-mate.browse-agents-view.close-button': 'Agentenansicht schließen',
  'ai-mate.browse-agents.scenario-pill.default-scenario-tag': 'Standard',
  'ai-mate.browse-agents.scenario-pill.inactive-scenario-tooltip': 'Inaktiv',
  'ai-mate.profile-card-preview.actions-title': 'Aktionen',
  'ai-mate.profile-card-preview.agent-default-title': 'Agent',
  'ai-mate.profile-card-preview.agent-description-label': 'Beschreibung',
  'ai-mate.profile-card-preview.agent-title-label': 'Titel',
  'ai-mate.profile-card-preview.conversation-starters-heading': 'Optionen für die Gesprächseinleitung',
  'ai-mate.profile-card-preview.empty-actions': 'Keine',
  'ai-mate.profile-card-preview.empty-conversation-starters': 'Keine',
  'ai-mate.profile-card-preview.empty-instructions': 'Keine',
  'ai-mate.profile-card-preview.empty-knowledge-scope': 'Nichts ausgewählt',
  'ai-mate.profile-card-preview.instructions-title': 'Anweisungen',
  'ai-mate.profile-card-preview.knowledge-title': 'Wissen',
  'ai-mate.profile-card-preview.regenerate-label': '{fieldName} neu generieren',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} – Kopie',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': 'Zum Neuanordnen ziehen',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error':
    'Änderungen konnten nicht gespeichert werden',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error':
    'Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error':
    'Ein Agent mit diesem Namen ist bereits vorhanden.',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': 'Entfernen',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text':
    'Optionen für die Gesprächseinleitung generieren',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, one {{fieldName} darf nicht mehr als {maxLength,number} Zeichen enthalten.} other {{fieldName} darf nicht mehr als {maxLength,number} Zeichen enthalten.}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': 'Weiter',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': 'Neu starten',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': 'Zur manuellen Einrichtung springen',
  'create-agent.owner-field.confirm-modal-cancel': 'Abbrechen',
  'create-agent.owner-field.confirm-modal-confirm': 'Fortfahren',
  'create-agent.owner-field.confirm-modal-content':
    'Sie sind im Begriff, den Besitzer dieses Agenten in {name} zu ändern. Nach der Änderung können Sie diesen Agenten nicht mehr bearbeiten oder verwalten.',
  'create-agent.owner-field.confirm-modal-title': 'Bearbeitungszugriff geht verloren',
  'create-agent.owner-field.owner-description': 'Dies ist die Person, die den Agenten bearbeiten oder verwalten kann.',
  'create-agent.owner-field.owner-label': 'Besitzer',
  'rovo-chat.agent-card.deactivated-name': '{name} (deaktiviert)',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': 'Zu viele Anfragen. Bitte warten Sie einen Moment.',
  'rovo-chat.browse-agents.agents-error-try-again-button': 'Erneut versuchen',
  'rovo-chat.browse-agents.all-agents-button': 'Alle',
  'rovo-chat.browse-agents.close-button': 'Schließen',
  'rovo-chat.browse-agents.create-agent-button': 'Erstellen',
  'rovo-chat.browse-agents.create-an-agent-button': 'Einen Agenten erstellen',
  'rovo-chat.browse-agents.create-button-disabled-tooltip':
    'Sie sind nicht berechtigt, Agenten auf dieser Site zu erstellen.',
  'rovo-chat.browse-agents.created-by-label': '<text>von</text> {creatorName}',
  'rovo-chat.browse-agents.development-button': 'Programmierungsagenten',
  'rovo-chat.browse-agents.favorite-agents-button': 'Favoriten',
  'rovo-chat.browse-agents.favourited-agent-label': 'Agentfavorit',
  'rovo-chat.browse-agents.modal-title': 'Agenten durchsuchen',
  'rovo-chat.browse-agents.my-agents-button': 'Meine Agenten',
  'rovo-chat.browse-agents.no-created-agents':
    'Anscheinend haben Sie noch keine Agenten erstellt. Beginnen Sie, indem Sie andere bestehende Agenten duplizieren, oder erstellen Sie einen ganz neuen.',
  'rovo-chat.browse-agents.no-created-agents-header': 'Noch keine Agenten erstellt',
  'rovo-chat.browse-agents.no-created-agents-header-no-permission': 'Sie haben keine Agenten erstellt',
  'rovo-chat.browse-agents.no-created-agents-no-permission':
    'Sie benötigen die Berechtigung eines Administrators, um auf dieser Site Rovo-Agenten erstellen zu können.',
  'rovo-chat.browse-agents.no-starred-agents':
    'Wenn Sie einen Lieblingsagenten haben oder einen Agenten häufig verwenden, markieren Sie ihn mit einem Stern, damit Sie leichter darauf zugreifen können.',
  'rovo-chat.browse-agents.no-starred-agents-header': 'Sie haben noch keinen Agenten mit Stern markiert',
  'rovo-chat.browse-agents.search-input.placeholder': 'Agenten suchen',
  'rovo-chat.browse-agents.search-templates-input.placeholder': 'Vorlagen suchen',
  'rovo-chat.browse-agents.see-all-agents-button': 'Alle Agenten anzeigen',
  'rovo-chat.browse-agents.templates-button': 'Vorlagen',
  'rovo-chat.create-agent.actions-section-description':
    'Fügen Sie Aktionen hinzu, mit denen Ihr Agent Aufgaben in Jira, Confluence und Jira Service Management ausführen kann. <link>Was sind Aktionen für den Agenten?</link>',
  'rovo-chat.create-agent.add-actions-button-label': 'Aktionen hinzufügen',
  'rovo-chat.create-agent.all-content-label': 'Alle Inhalte',
  'rovo-chat.create-agent.back-button': 'Zurück',
  'rovo-chat.create-agent.beta-lozenge': 'Beta',
  'rovo-chat.create-agent.confirm-leave-modal.body':
    'Sie haben Ihren Agenten noch nicht erstellt. Möchten Sie ihn verwerfen?',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': 'Abbrechen',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': 'Ja, Agent verwerfen',
  'rovo-chat.create-agent.confirm-leave-modal.title': 'Nicht fertiggestellter Agent',
  'rovo-chat.create-agent.confirm-restart-modal.body':
    'Möchten Sie die Änderungen, die Sie an diesem Agenten vorgenommen haben, wirklich verwerfen?',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': 'Bestätigen',
  'rovo-chat.create-agent.confirm-restart-modal.title': 'Erstellung neu starten',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    'Benutzer können diese Optionen verwenden, um einen Chat mit dem Agenten zu beginnen. Wenn Ihnen keine Optionen einfallen, können wir sie für Sie generieren.',
  'rovo-chat.create-agent.conversation-starters-field-label': 'Optionen für die Gesprächseinleitung',
  'rovo-chat.create-agent.create-agent-button': 'Erstellen',
  'rovo-chat.create-agent.ctions-section-title': 'Aktionen',
  'rovo-chat.create-agent.description-field-description':
    'Benutzer können die Beschreibung im Profil des Agenten nutzen, um mehr darüber zu erfahren.',
  'rovo-chat.create-agent.description-field-label': 'Beschreibung',
  'rovo-chat.create-agent.description-field-placeholder':
    'Beschreiben Sie Ihren Agenten kurz (z. B. "kreativer Autor für Marketing-Blogs").',
  'rovo-chat.create-agent.instructions-field-description':
    'Wie soll sich dieser Agent verhalten? Welche Möglichkeiten hat er? <link>Weitere Informationen zum Verfassen von Anweisungen für einen Agenten</link>',
  'rovo-chat.create-agent.instructions-field-label': 'Anweisungen',
  'rovo-chat.create-agent.instructions-field-placeholder': 'Anweisungen für diesen Agenten anpassen',
  'rovo-chat.create-agent.intro-description-part-1':
    'Erstellen Sie einen Agenten mit spezialisiertem Wissen, der Fragen beantworten, Inhalte erstellen und überprüfen sowie Aufgaben erledigen kann, damit Sie schneller vorankommen.',
  'rovo-chat.create-agent.intro-description-part-2':
    'Wenn Sie keine Hilfe benötigen, können Sie <bold>zur manuellen Einrichtung springen</bold>.',
  'rovo-chat.create-agent.intro-description-part-3': 'Ansonsten helfe ich Ihnen nun dabei, einen Agenten zu erstellen.',
  'rovo-chat.create-agent.intro-step-1-content':
    'Ich erstelle anhand Ihrer Angaben Anweisungen für den Agenten. Sagen Sie mir einfach, wofür Sie ihn verwenden möchten.',
  'rovo-chat.create-agent.intro-step-1-title': 'Verwendung des Agenten beschreiben',
  'rovo-chat.create-agent.intro-step-2-content':
    'Lassen Sie uns gemeinsam einen Namen für Ihren Agenten festlegen und seine Persönlichkeit bestimmen. Teilen Sie mir mit, ob Ihr Agent einfühlsam, direkt oder lustig sein soll.',
  'rovo-chat.create-agent.intro-step-2-title': 'Persönlichkeit verleihen',
  'rovo-chat.create-agent.intro-step-3-content':
    'Klicken Sie auf <bold>Weiter</bold>, um Ihren neuen Agenten zu überprüfen und Aktionen, Wissen sowie ein Profilbild hinzuzufügen. Wenn Sie fertig sind, klicken Sie auf <bold>Erstellen</bold>.',
  'rovo-chat.create-agent.intro-step-3-content-skills':
    'Klicken Sie auf <bold>Weiter</bold>, um Ihren neuen Agenten zu überprüfen und Fähigkeiten, Wissen sowie ein Profilbild hinzuzufügen. Wenn Sie fertig sind, klicken Sie auf <bold>Erstellen</bold>.',
  'rovo-chat.create-agent.intro-step-3-title': 'Agenten überprüfen und erstellen',
  'rovo-chat.create-agent.intro-title': '👋 Lassen Sie uns Ihren Agenten erstellen',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': 'Alle Projekte',
  'rovo-chat.create-agent.jira-filter-placeholder-galaxia': 'Alle Bereiche',
  'rovo-chat.create-agent.jsm-checkbox-label': 'Jira Service Management',
  'rovo-chat.create-agent.jsm-filter-knowledge-base-placeholder': 'Nach Wissensdatenbank suchen',
  'rovo-chat.create-agent.knowledge-field-description':
    'Legen Sie fest, welche Informationen dem Agenten zur Verfügung stehen sollen, indem Sie ihm nur den Zugriff auf von Ihnen angegebene Quellen gestatten.',
  'rovo-chat.create-agent.knowledge-field-label': 'Wissen',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': 'Nur diese Quellen als Referenz nutzen',
  'rovo-chat.create-agent.knowledge-select.object-resolver-label': 'Links',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': 'Vorgeschlagen',
  'rovo-chat.create-agent.manage-actions-button-label': 'Aktionen verwalten',
  'rovo-chat.create-agent.name-field-description': 'Benutzer können diesen Namen verwenden, um den Agenten zu finden.',
  'rovo-chat.create-agent.name-field-label': 'Name',
  'rovo-chat.create-agent.name-field-placeholder': 'Geben Sie Ihrem Agenten einen Namen.',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error':
    'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    'Hallo! Ich bin hier, um Ihnen bei der Erstellung eines benutzerdefinierten Agenten zu helfen. Welche Aufgaben soll Ihr Agent für Sie übernehmen?',
  'rovo-chat.create-agent.nl-input-field.input-label': 'Einen Agenten erstellen',
  'rovo-chat.create-agent.nl-input-field.placeholder': 'Nachricht eingeben',
  'rovo-chat.create-agent.nl-input-field.send-button-label': 'Senden',
  'rovo-chat.create-agent.page-title': 'Einen Agenten erstellen',
  'rovo-chat.create-agent.page-title-edit': 'Agenten bearbeiten',
  'rovo-chat.create-agent.search-for-pages-placeholder': 'Nach Seiten suchen',
  'rovo-chat.create-agent.search-for-spaces-placeholder': 'Nach Bereichen suchen',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': 'Alle',
  'rovo-chat.create-agent.select-action-modal-beta-tag': 'Beta',
  'rovo-chat.create-agent.select-action-modal-cancel-button': 'Abbrechen',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': 'Schließen',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, one {Für optimale Leistung sollten Sie weniger als {count,number} Aktion auswählen.} other {Für optimale Leistung sollten Sie weniger als {count,number} Aktionen auswählen.}}',
  'rovo-chat.create-agent.select-action-modal-save-button': 'Speichern',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': 'Aktionen suchen',
  'rovo-chat.create-agent.select-action-modal-title': 'Aktionen hinzufügen',
  'rovo-chat.create-agent.select-content-under-label': '"Inhalt unter" auswählen',
  'rovo-chat.create-agent.select-spaces-label': 'Bereiche auswählen',
  'rovo-chat.create-agent.selected-actions-label': 'Ausgewählte Aktionen:',
  'rovo-chat.create-agent.unknown-owner': 'Unbekannt',
  'rovo-chat.create-agent.update-agent-button': 'Aktualisieren',
  'rovo-chat.edit-agent.confirm-discard-modal.body':
    'Wenn Sie fortfahren, gehen die nicht gespeicherten Änderungen verloren. Wählen Sie "Abbrechen" aus, um mit der Bearbeitung dieses Agenten fortzufahren.',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': 'Fortfahren, Änderungen verwerfen',
  'rovo-chat.edit-agent.confirm-discard-modal.title': 'Änderungen verwerfen',
  'rovo-chat.view-agent.about-label': 'Info',
  'rovo-chat.view-agent.actions-label': 'Aktionen',
  'rovo-chat.view-agent.all-knowledge-added': 'Gesamtes Unternehmenswissen',
  'rovo-chat.view-agent.behaviour-label': 'Verhalten',
  'rovo-chat.view-agent.beta-label': 'Beta',
  'rovo-chat.view-agent.beta-tag': 'Beta',
  'rovo-chat.view-agent.chat-to-agent-button': 'Mit Agent chatten',
  'rovo-chat.view-agent.close-button': 'Schließen',
  'rovo-chat.view-agent.copy-behaviour-tooltip': 'Verhalten kopieren',
  'rovo-chat.view-agent.copy-instructions-label': 'Kopieren',
  'rovo-chat.view-agent.copy-instructions-tooltip': 'Anweisungen kopieren',
  'rovo-chat.view-agent.created-by-label': '<text>von</text> {agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': 'Anz. an Favoriten',
  'rovo-chat.view-agent.go-back-label': 'Zurück',
  'rovo-chat.view-agent.hidden-instructions-description':
    'Bei Forge-Agenten, die mit Code erstellt wurden, sind die Anweisungen aus Datenschutzgründen ausgeblendet.',
  'rovo-chat.view-agent.hidden-instructions-title': 'Diese Anweisungen sind privat',
  'rovo-chat.view-agent.hidden-knowledge-description':
    'Forge-Agenten, die mit Code erstellt wurden, verwenden keine typischen Wissensquellen.',
  'rovo-chat.view-agent.inactive-action-tooltip': 'Inaktiv',
  'rovo-chat.view-agent.instructions-label': 'Anweisungen',
  'rovo-chat.view-agent.knowledge-label': 'Wissen',
  'rovo-chat.view-agent.member-count':
    '{count, plural, one {{count,number} Mitglied} other {{count,number} Mitglieder}}',
  'rovo-chat.view-agent.modal-title': 'Agenten durchsuchen',
  'rovo-chat.view-agent.no-actions': 'Keine Aktionen',
  'rovo-chat.view-agent.no-behaviour-placeholder': 'Kein benutzerdefiniertes Verhalten für diesen Agenten vorhanden',
  'rovo-chat.view-agent.no-instruction-placeholder':
    'Keine benutzerdefinierten Anweisungen für diesen Agenten vorhanden',
  'rovo-chat.view-agent.no-knowledge-added': 'Kein Unternehmenswissen',
  'rovo-chat.view-agent.no-scenarios': 'Keine Szenarien',
  'rovo-chat.view-agent.no-skills': 'Keine Fähigkeiten',
  'rovo-chat.view-agent.no-teams': 'Keinem Team angehörig',
  'rovo-chat.view-agent.open-chat-label': 'Chat öffnen',
  'rovo-chat.view-agent.reactions-metadata-label': 'Anz. an Reaktionen',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo-Agent',
  'rovo-chat.view-agent.scenarios-label': 'Szenarien',
  'rovo-chat.view-agent.skills-label': 'Fähigkeiten',
  'rovo-chat.view-agent.teams-label': 'Teams',
  'rovo-chat.view-agent.users-metadata-label': 'Anz. an Benutzern',
  'rovo.agent.scenarios.scenarioModal.actionsLabel': 'Aktionen',
  'rovo.agent.scenarios.scenarioModal.instructionsLabel': 'Anweisungen',
  'rovo.agent.scenarios.scenarioModal.knowledgeSourcesLabel': 'Wissen',
  'rovo.agent.scenarios.scenarioModal.mcpServersLabel': 'MCP-Server',
  'rovo.agent.scenarios.scenarioModal.noActions': 'Keine Aktionen',
  'rovo.agent.scenarios.scenarioModal.noInstructions': 'Keine Anweisungen',
  'rovo.agent.scenarios.scenarioModal.noMcpServers': 'Keine MCP-Server',
  'rovo.agent.scenarios.scenarioModal.noSkills': 'Keine Fähigkeiten',
  'rovo.agent.scenarios.scenarioModal.skillsLabel': 'Fähigkeiten',
};
